/**
 * Enrich a graph so the worker can parse every node without a second fetch.
 * The saved-graph path uses the API's `assembled()` endpoint for this; the
 * carried-graph path (web test-in-browser, playground demos) hands the graph
 * straight to the worker and bypasses the API, so the sender does it here.
 *
 * Pure function: never mutates the input graph.
 *
 * Node types enriched today:
 *   - `transfer` → attaches `parameters` resolved from the WorkflowAction.
 *
 * Node types enriched when their runtime handlers land:
 *   - `action` → attaches the referenced NodeActionGroup's member parameters
 *     once a concrete action type has a worker-side executor.
 */
export function enrichGraphForDispatch(graph, resolvers) {
    const nodes = graph.nodes.map(node => {
        if (node.type === 'transfer' && resolvers.getTransferParameters) {
            // Author-side skip: an unpicked transfer node has an empty id. Let it
            // ride through so the server's save-time check (or worker parse)
            // flags it with the node ref instead of us silently rewriting it.
            if (!node.workflowActionId)
                return node;
            const parameters = resolvers.getTransferParameters(node.workflowActionId);
            if (!parameters)
                return node;
            return { ...node, parameters };
        }
        return node;
    });
    return { ...graph, nodes };
}
//# sourceMappingURL=enrich-for-dispatch.js.map